import { render, staticRenderFns } from "./desc-support.mpx?vue&type=template&id=38708fb2&isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex"
import script from "./desc-support.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex"
export * from "./desc-support.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex"
import style0 from "./desc-support.mpx?vue&type=style&index=0&id=38708fb2&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_280dae6c%22%7D&isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports